export const CardsIcon = ({ className = "w-5 h-5" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <rect x="4" y="7.5" width="7.5" height="11" rx="1.4" transform="rotate(-11 7.75 13)" />
    <rect x="12.5" y="7.5" width="7.5" height="11" rx="1.4" transform="rotate(11 16.25 13)" />
    <rect x="8.2" y="4.8" width="7.6" height="11.4" rx="1.4" fill="currentColor" fillOpacity="0.18" />
  </svg>
);
